import { Component, ElementRef, HostBinding, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfigService } from '@nx-ratenow/core/config';
import { LayoutService } from '@nx-ratenow/core/data-access-layaout';
import { LocalService } from '@nx-ratenow/core/data-access-local-storage';
import { UtilsService } from '@nx-ratenow/shared/data-access-utils';
import { AplicationTypeName, ColorSchemeName, EnumsByType } from '@nx-ratenow/shared/enums';
import { PopoverService } from '@nx-ratenow/shared/feature-popover';
import { Observable, of } from 'rxjs';
import { map, startWith, switchMap } from 'rxjs/operators';
import { AppsMenuComponent } from '../apps-menu/apps-menu.component';

@Component({
  standalone: false,
  selector: 'nx-ratenow-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit {
  languages = ['es', 'en', 'it', 'dt', 'ca', 'fr'];
  enumsByType = EnumsByType;

  selectedLanguage = null;

  @Input() mobileQuery!: boolean;

  @Input()
  @HostBinding('class.shadow-b')
  hasShadow!: boolean;

  megaMenuOpen$: Observable<boolean> = of(false);

  aplicationType = null;
  aplicationTypeName = AplicationTypeName;

  constructor(
    private layoutService: LayoutService,
    private configService: ConfigService,
    private translate: TranslateService,
    private localService: LocalService,
    private utilsService: UtilsService,
    private readonly popoverService: PopoverService
  ) {
    this.aplicationType = this.configService.aplicationName;
  }

  isHorizontalLayout$: Observable<boolean> = this.configService.config$.pipe(map((config: any) => config.layout === 'horizontal'));
  isVerticalLayout$: Observable<boolean> = this.configService.config$.pipe(map((config: any) => config.layout === 'vertical'));
  isNavbarInToolbar$: Observable<boolean> = this.configService.config$.pipe(map((config: any) => config.navbar.position === 'in-toolbar'));
  isNavbarBelowToolbar$: Observable<boolean> = this.configService.config$.pipe(map((config: any) => config.navbar.position === 'below-toolbar'));
  userVisible$: Observable<boolean> = this.configService.config$.pipe(map((config: any) => config.toolbar.user.visible));

  ngOnInit(): void {
    this.selectedLanguage = this.languages.find((val) => val === this.translate.currentLang);

    this.utilsService.getEnumByType(EnumsByType.LANGUAGES).subscribe((data) => {
      this.languages = data.filter((item) => this.languages.includes(item));
    });
  }

  openSidenav(): void {
    this.layoutService.openSidenav();
  }

  setDarkMode(): void {
    this.configService.enabledDarkMode = !this.configService.enabledDarkMode;
    let colorScheme: ColorSchemeName = ColorSchemeName.default;
    if (this.configService.aplicationName === AplicationTypeName.closeTheLoop) {
      colorScheme = ColorSchemeName.ctl;
    }

    this.localService.saveData('dark-mode', 'false');

    if (this.configService.enabledDarkMode) {
      colorScheme = ColorSchemeName.dark;
      this.localService.saveData('dark-mode', 'true');
    }

    this.configService.updateConfig({
      style: {
        colorScheme
      }
    });
  }

  switchLanguage(languadeId: string): void {
    this.selectedLanguage = this.languages.find((val) => val === languadeId);
    this.translate.use(languadeId);
  }

  getDarkMode() {
    return this.configService.enabledDarkMode;
  }

  openMegaMenu(origin: ElementRef | HTMLElement): void {
    this.megaMenuOpen$ = of(
      this.popoverService.open({
        content: AppsMenuComponent,
        origin,
        offsetY: 12,
        position: [
          {
            originX: 'start',
            originY: 'bottom',
            overlayX: 'start',
            overlayY: 'top'
          },
          {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'top'
          }
        ]
      })
    ).pipe(
      switchMap((popoverRef) => popoverRef.afterClosed$.pipe(map(() => false))),
      startWith(true)
    );
  }

  // openSearch(): void {
  //   this.layoutService.openSearch();
  // }

  // openQuickpanel(): void {
  //   this.layoutService.openQuickpanel();
  // }
}
